import {CreateCompanyForm} from '../../page-container/create/create-company-form';

export function CreateCompanyPageGuard(): JSX.Element {
    return <CreateCompanyForm />;
}
